import { z } from 'zod';

/**
 * Strict rules aligned with np24_is_valid_billing_email() in inc/woocommerce/hooks.php.
 *
 * @param {string} email
 * @returns {boolean}
 */
function passesStrictBillingEmailRules(email) {
  if (!email || email.includes(' ')) {
    return false;
  }

  if ((email.match(/@/g) || []).length !== 1) {
    return false;
  }

  if (email.includes('..')) {
    return false;
  }

  const parts = email.split('@');
  const local = parts[0];
  const domain = parts[1];

  if (!local || !domain) {
    return false;
  }

  if (!/^[a-zA-Z0-9._+-]+$/.test(local)) {
    return false;
  }

  if (local.startsWith('.') || local.endsWith('.')) {
    return false;
  }

  if (!/^[a-zA-Z0-9.-]+$/.test(domain)) {
    return false;
  }

  if (/^[.-]|[.-]$/.test(domain)) {
    return false;
  }

  if (!domain.includes('.')) {
    return false;
  }

  const labels = domain.split('.');

  for (const label of labels) {
    if (!label || label.length > 63) {
      return false;
    }

    if (/^-|-$/.test(label)) {
      return false;
    }

    if (!/^[a-zA-Z0-9-]+$/.test(label)) {
      return false;
    }
  }

  const tld = labels[labels.length - 1];

  return /^[a-zA-Z]{2,}$/.test(tld);
}

export const billingEmailSchema = z
  .string()
  .trim()
  .email()
  .refine(passesStrictBillingEmailRules);

/**
 * @param {string} email
 * @returns {boolean}
 */
export function isValidBillingEmail(email) {
  return billingEmailSchema.safeParse(email).success;
}
